// Canal de suporte — fonte única de verdade.
// Para trocar o número do suporte, altere apenas SUPPORT_WHATSAPP_NUMBER.
export const SUPPORT_WHATSAPP_NUMBER = "+5534998800229";

// Número de exibição, formatado para leitura humana.
export const SUPPORT_WHATSAPP_DISPLAY = "+55 (34) 99880-0229";

// Monta a URL do WhatsApp (wa.me) com uma mensagem opcional pré-preenchida.
export const getSupportWhatsAppUrl = (message) => {
  const digits = SUPPORT_WHATSAPP_NUMBER.replace(/\D/g, "");
  const base = `https://wa.me/${digits}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

// URL padrão do suporte, sem mensagem pré-preenchida.
export const SUPPORT_WHATSAPP_URL = getSupportWhatsAppUrl();
